import { useEffect } from "react";

const useBodyClasses = (classes = []) => {
    useEffect(() => {
        if (!classes || classes.length === 0) return;

        classes.forEach((className) => document.body.classList.add(className));

        return () => {
            classes.forEach((className) => document.body.classList.remove(className));
        };
    }, [classes]);
};

export default useBodyClasses;
